import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';

import { ShareDirectivesModule } from 'src/app/core/directives/directives.module';
import { BaseFormModule } from 'src/app/pages/shared/base/modules/base-form.module';
import { MaterialModule } from 'src/app/shared/modules/material/material.module';

@Component({
    selector: 'app-search-input-lottery',
    templateUrl: './search-input-lottery.component.html',
    styleUrls: ['./search-input-lottery.component.scss'],
    imports: [
        BaseFormModule,
        MaterialModule,
        NgbModule,
        ShareDirectivesModule,
    ]
})
export class SearchInputLotteryComponent implements OnInit {
  inputCount?: string;
  @Input() id?: number;
  @Input() value: any;
  @Input('form') input_form: FormGroup;
  @Input() isAuthenticate?: boolean = true;
  @Input('groupName') input_formGroupName: string;
  @Input('searchLoading') loading: boolean = false;

  @Output('value') output_value = new EventEmitter<number>();
  @Output('onSubmit') output_onSubmit = new EventEmitter<boolean>();

  subscription: Subscription;

  constructor() {}

  ngOnInit() {}

  emit(event) {
    this.output_value.emit(event.target.value);
  }

  onSubmit() {
    this.output_onSubmit.emit(true);
  }
}
